<div class="customer-points-root" *transloco="let t">
  <div *ngIf="!loading && seriesChips.length == 0" class="points-list-empty">
    No product found. Register a product and start to receiving points.
  </div>
  <div *ngIf="!loading && seriesChips.length > 0" class="profile"
        [matTooltip]="((data?.businessInfo?.name?.length ?? 0) > 20 ? data?.businessInfo?.name : '') ?? ''">
    <div class="top-header">
      <div class="points-timeline">
        <div class="points-timeline-label">
          Points Timeline
        </div>
        <div class="series-selector">
          <mat-icon>
            print
          </mat-icon>
          <app-filter-container [isSingleSelection]="true"
                              (selectFilterClick)="updateFilter($event)"
                              [seriesChips]="this.seriesChips"
                              [filters]="this.seriesFilter"></app-filter-container>
        </div>
        
      </div>
      <div class="button-panel">
        <app-icon-button id="lnr-generate-report-button" v2 whiteBackground borderless icon="assignment_outline" (clickAction)="openCreateReportModal()"> {{labels.generateReport}} </app-icon-button>
      </div>
      <div class="button-panel">
        <app-icon-button 
          *ngIf="!viewOnly && !isDisabled()"
          [disabled]="isTimelineDisabled()"
          id="create-point-transaction-click" 
          v2 borderless icon="add_2" 
          (clickAction)="openCreatePointTransaction()"> 
          {{t('create-point-transaction')}} 
        </app-icon-button>
      </div>
    </div>
        
    <div class="scrollable-area">
      <app-points-summary 
        [pointSummary]="data?.pointSummary" 
        [family]="getSelectedFamily()" 
        [viewOnly]="viewOnly" 
        [reloadData]="reloadData" 
        [sysAdminPointBalance]="data?.sysAdminPointBalance" 
        [timelineDisabled]="isTimelineDisabled()"
        [businessId]="businessId">
      </app-points-summary>
      <div class="points-avaiable"
        *ngIf="!isTimelineDisabled()"
        [ngClass]="{'hidden': !data?.sysAdminPointBalance || viewOnly}">
        <div class="available-label">{{t('available-business')}} <span><strong>{{data?.sysAdminPointBalance?.businessBalance | number:'': language}}</strong></span></div>
        <div class="points-left">{{t('points-left')}}
          <div>{{t('points-left-month')}} <span><strong>{{data?.sysAdminPointBalance?.totalBalancePerMonth | number:'': language}}</strong></span></div>
          <div>{{t('points-left-year')}} <span><strong>{{data?.sysAdminPointBalance?.totalBalancePerYear | number:'': language}}</strong></span></div>
        </div>
      </div>
      <app-date-tab-selector
        class="tab-selector"
        [businessRegisterDate]="data?.businessInfo?.registerDate"
        [filters]="filters"
        (selectFilterClick)="updateFilter($event)"
      ></app-date-tab-selector>
      <div class="timeline-header">
        <div class="filter-container">
          <span>{{ t('filter-by') }}</span>
          <app-filter-container
            (selectFilterClick)="updateFilter($event)"
            [baseSimpleChipData]="chipContents"
            [filters]="this.filters"
          ></app-filter-container>
        </div>
        <div class="month-info-container">
          <div class="chip-info">
            <div class="chip-icon-content">
              <mat-icon class="icon add">add_task</mat-icon>
            </div>
            <div class="chip-text-content">
              <span>{{ t('added')}}</span>
              <span class="chip-number">{{ addedPointsTotal }}</span>
            </div>
          </div>
          <div class="chip-info">
            <div class="chip-icon-content">
              <mat-icon class="icon spend">hourglass_bottom</mat-icon>
            </div>
            <div class="chip-text-content">
              <span>{{ t('expired') }}</span>
              <span class="chip-number">{{ expiringPointsTotal }}</span>
            </div>
          </div>
        </div>
      </div>
      <app-timeline [businessId]="businessId" [filters]="allFilters"
                    (addedPoint)="handleAddedPoints($event)"
                    (expiringPoints)="handleExpiringPoints($event)"
      ></app-timeline>
    </div>
  </div>
  <mat-spinner diameter="100" *ngIf="loading"></mat-spinner>
</div>
